import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import * as THREE from 'three';
import { useDragHandler } from '../../utils/useDragHandler';
import { setCommandType, setCommandMessage, setOperationData } from '../../redux/operationSlice';
import { clearSelection } from '../../redux/selectionSlice';
import { COMMANDS } from '../../utils/commonProperties';
import './PanelTypeMenus.css';

export default function BellTypeMenu({
  x,
  y,
  onClose,
  details = {},
  scene,
  onDrag
}) {
  const menuRef = useRef(null);
  const dispatch = useDispatch();
  const { handleMouseDown } = useDragHandler(onDrag);

  // Find the selected bell object in the scene
  let selectedBellObj = null;
  let selectedBellUserData = null;
  let bellTrafoObj = null;
  let parentWireObj = null;

  if (scene && details.id) {
    // First find the selected object
    scene.traverse(obj => {
      if (obj.userData?.id === details.id) {
        selectedBellObj = obj;
        selectedBellUserData = obj.userData;
      }
    });

    // Get branchID from selected object
    const branchID = selectedBellUserData?.branchID;

    // Find bellTrafo and parentWire using branchID
    if (branchID) {
      scene.traverse(obj => {
        if (obj.userData?.type === 'bellTrafo' && obj.userData?.branchID === branchID) {
          bellTrafoObj = obj;
        }
        if ((obj.userData?.function === 'wireBell' || obj.userData?.type === 'wireBell') &&
          obj.userData?.branchID === branchID) {
          parentWireObj = obj;
        }
      });
    }

    // If selected object is bellTrafo, use it directly
    if (selectedBellUserData?.type === 'bellTrafo') {
      bellTrafoObj = selectedBellObj;
    }

    // If selected object is wireBell, use it as parentWire
    if (selectedBellUserData?.function === 'wireBell' || selectedBellUserData?.type === 'wireBell') {
      parentWireObj = selectedBellObj;
    }
  }

  const bellTrafoUserData = bellTrafoObj?.userData;

  const handleMouseDownWithStop = (e) => {
    e.stopPropagation();
    handleMouseDown(e, menuRef);
  };

  const handleAddBellButton = () => {
    if (!scene) return;

    // We need either bellTrafo or parentWire to proceed
    if (!bellTrafoObj && !parentWireObj) {
      console.warn("❌ Bell trafo veya wire bulunamadı");
      return;
    }

    const branchID = bellTrafoUserData?.branchID || parentWireObj?.userData?.branchID || selectedBellUserData?.branchID;

    // Find the nearest point on the bell wire for snapping
    let bellWireSnapPoint = null;
    if (parentWireObj && parentWireObj.geometry?.attributes?.position) {
      const pos = parentWireObj.geometry.attributes.position;
      // Use trafo position or wire midpoint as reference
      const refPosition = bellTrafoObj ? bellTrafoObj.position.clone() :
        new THREE.Vector3(pos.getX(0), pos.getY(0), pos.getZ(0));

      // Find the closest vertex on the wire
      let minDist = Infinity;
      for (let i = 0; i < pos.count; i++) {
        const vertex = new THREE.Vector3(
          pos.getX(i),
          pos.getY(i),
          pos.getZ(i)
        );
        const dist = vertex.distanceTo(refPosition);
        if (dist < minDist) {
          minDist = dist;
          bellWireSnapPoint = vertex.clone();
        }
      }
    }

    // Source data for the bell button
    const sourceData = {
      type: 'bellWire',
      panelID: parentWireObj?.userData?.panelID || bellTrafoUserData?.panelID || selectedBellUserData?.panelID,
      branchID: branchID,
      wireID: parentWireObj?.userData?.id,
      userData: {
        panelID: parentWireObj?.userData?.panelID || bellTrafoUserData?.panelID || selectedBellUserData?.panelID,
        branchID: branchID,
        wireID: parentWireObj?.userData?.id
      }
    };

    // ✅ Önce seçimi temizle (gizmoların köşelere tıklamayı engellemesini önle)
    dispatch(clearSelection());

    // Dispatch DRAW_BELL_BUTTON command
    dispatch(setCommandType(COMMANDS.DRAW_BELL_BUTTON));
    dispatch(setCommandMessage("Zil butonu için konum seçin"));
    dispatch(setOperationData({
      source: sourceData,
      bellWireSnapPoint: bellWireSnapPoint ? {
        x: bellWireSnapPoint.x,
        y: bellWireSnapPoint.y,
        z: bellWireSnapPoint.z
      } : null
    }));

    onClose();
  };

  return (
    <div
      ref={menuRef}
      className="panel-type-menu"
      style={{ left: x, top: y }}
    >
      <div
        onMouseDown={handleMouseDownWithStop}
        className="panel-type-menu-header"
      >
        Zil Hattı Detay
        <button
          className="close-button"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          ×
        </button>
      </div>
      <div className="panel-type-options">
{/*  
        <div className="panel-type-details-box">
          <table className="panel-type-details-table">
            <tbody>
              <tr>
                <td className="td">Seçili Tip</td>
                <td style={{ color: '#aaa', fontSize: '11px' }}>
                  {selectedBellUserData?.type || selectedBellUserData?.function || '-'}
                </td>
              </tr>
              <tr>
                <td className="td">Branch ID</td>
                <td style={{ color: '#aaa', fontSize: '11px' }}>
                  {bellTrafoUserData?.branchID || parentWireObj?.userData?.branchID || selectedBellUserData?.branchID || '-'}
                </td>
              </tr>
              {bellTrafoObj && (
                <tr>
                  <td className="td">Trafo</td>
                  <td style={{ color: '#7f7', fontSize: '11px' }}>Mevcut</td>
                </tr>
              )}
              {parentWireObj && (
                <tr>
                  <td className="td">Wire</td>
                  <td style={{ color: '#7f7', fontSize: '11px' }}>Mevcut</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
 */}
        <div className="panel-type-buttons">
          <button
            className="my-button"
            onClick={handleAddBellButton}
          >
            Zil Butonu Ekle
          </button>
        </div>
      </div>
    </div>
  );
}
